import React from "react";
import DataComponent from "components/common/DataComponent";
import CommVaultData from "./CommVaultData";
import { useState } from "react";
import { Spin } from "antd";

const CommVaultSection = ({isUserAllowed}) => {

  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <div
      id="site-section"
      className="section-container"
      style={{
        backgroundColor: "#FFFFFF",
        padding: "24px",
        border: "1px solid #E5E7EB",
        borderRadius: "12px",
        boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1)",
        position: "relative"
      }}
    >
      {isSubmitting && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
            backgroundColor: "rgba(255, 255, 255, 0.9)",
            borderRadius: "12px",
            backdropFilter: "blur(2px)"
          }}
        >
          <div style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "16px"
          }}>
            <Spin size="large" />
            <span style={{ 
              fontWeight: 600, 
              fontSize: "16px",
              color: "#374151"
            }}>
              Processing...
            </span>
          </div>
        </div>
      )}
      <DataComponent />
      <CommVaultData setIsSubmitting={setIsSubmitting} isUserAllowed={isUserAllowed}/>
    </div>
  );
};

export default CommVaultSection;
